module.exports = __webpack_public_path__ + "img/Register.60ea92e4.svg";